module.exports = __webpack_public_path__ + "static/media/fee-structure.73f91762.pdf";